import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'spr-coach-profile-sectors',
	templateUrl: './coach-profile-sectors.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'w-full xl:w-2/6 flex-none',
	},
})
export class CoachProfileSectorsComponent {
	@Input() public sectors: string[];

	constructor() {}
}
